{
  "agb-dialog": {
    "text": {
      "agb": "Všeobecné obchodní podmínky"
    },
    "buttons": {
      "close": "Zavři"
    }
  }
}
